var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscription-card streaming-device p-3 d-flex flex-column justify-content-center align-items-center"},[_c('h5',{staticClass:"mb-3 add-new-bank-account"},[_vm._v(_vm._s(_vm.$t('Add new bank account')))])])}
var staticRenderFns = []

export { render, staticRenderFns }